<div class="view-print">
  <!-- Single white pixel for background scrim -->
  <img class="view-print__scrim" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=">

  <!-- Actual Image -->
  <img [src]="imageUrl" class="view-print__image">
</div>